export default __webpack_public_path__ + "static/media/grey-tee.bb8cf628.jpg";